export enum FieldOptionsImageProportion {
    // Exact accordance
    precise = 'precise',

    // Not greater than
    less = 'less',
}
